import http from "./httpService";
import { apiUrl } from "../config";

// need to hit a get invoice history endpoint here and need to specify the correct route
export const getInvoiceHistory = () => {
  // return http.get(`${apiUrl}Delivery/DeliveryHistory`, { params: { from: fromDate, to: toDate } })
  return http.get(`${apiUrl}InvoiceMast/ViewInvoiceHistory`);
};

export const getExportInvoices = () => {
  return http.get(`${apiUrl}InvoiceMast/ExportInvoiceHistory`, {
    responseType: "blob",
  });
};
